import {FeatureType} from '../enums/feature-type.enum';
import {ImageType} from '../enums/image-type.enum';
import {ImageColorType} from '../enums/image-color-type.enum';
import { featurecolors } from './feature-colors';

export class FeatureImages {

  private static pathSeparator = '/';
  private static pathPrefix = ['assets', 'images'];
  private static infixSeparator = '_';
  private static defaultFileExtension = 'svg';

  private static imageTypeToPrefix = {
    [ImageType.Icon]: ['ic'],
    [ImageType.HeaderIcon]: ['ic', 'hd'],
    [ImageType.MenuIcon]: ['ic', 'menu'],
    [ImageType.Background]: ['bg'],
  };

  private static featureTypeToFileName = {
    [FeatureType.Admin]: 'admin',
    [FeatureType.CastMeasurements]: 'castMeasurement',
    [FeatureType.CreateCharacter]: 'characterMeasurement',
    [FeatureType.CreateCast]: 'createCast'
  };

  private static colorTypeToSuffix = {
    [ImageColorType.Default]: '',
    [ImageColorType.Inverted]: 'white',
  };

  private static featureTypeToDefaultColor = {
    [FeatureType.Admin]: 'magenta',
    [FeatureType.CastMeasurements]: 'magenta',
    [FeatureType.CreateCharacter]: 'magenta',
  };

  private static featureTypeToBackgroundColor = {
    [FeatureType.Admin]: featurecolors.Admin,
    [FeatureType.CastMeasurements]: featurecolors.CastMeasurements,
    [FeatureType.CreateCharacter]: featurecolors.CreateCharacter,
    [FeatureType.CreateCast]: featurecolors.CreateCast,

    undefined: featurecolors.Unknown,
  };

  /* istanbul ignore next */
   public static getImagePath({ featureType = FeatureType.Admin, imageType = ImageType.Icon, colorType = ImageColorType.Default}: {featureType?: FeatureType, imageType?: ImageType, colorType?: ImageColorType} = {}) {
    const fileNameParts = [
      ...FeatureImages.imageTypeToPrefix[imageType],
      FeatureImages.featureTypeToFileName[featureType],
      FeatureImages.colorTypeToSuffix[colorType] || FeatureImages.featureTypeToDefaultColor[featureType],
    ];

    const path = FeatureImages.pathPrefix.join(FeatureImages.pathSeparator) + FeatureImages.pathSeparator;
    const fileName = fileNameParts
      .join(FeatureImages.infixSeparator);
    const extension = FeatureImages.defaultFileExtension;

    return `${path}${fileName}.${extension}`;
  }

  public static getImageBackgroundColor({featureType}: {featureType?: FeatureType} = {}) {
    return FeatureImages.featureTypeToBackgroundColor[featureType];
  }
}
